__turbopack_context__.v({
  "link": "links-module-scss-module__xazbsq__link",
});
